// ═══════════════════════════════════════════════════════════════
// API: Contratos
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const contractsAPI = {
  // Obtener todos los contratos
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.estado) params.append('estado', filters.estado);
    if (filters.employeeId) params.append('employeeId', filters.employeeId);
    if (filters.tipo) params.append('tipo', filters.tipo);

    const response = await api.get(`/contracts?${params.toString()}`);
    return response.data;
  },

  // Obtener contratos próximos a vencer
  getExpiring: async () => {
    const response = await api.get('/contracts/expiring');
    return response.data;
  },

  // Obtener historial de contratos de un empleado
  getEmployeeHistory: async (employeeId) => {
    const response = await api.get(`/contracts/employee/${employeeId}`);
    return response.data;
  },

  // Obtener un contrato por ID
  getById: async (id) => {
    const response = await api.get(`/contracts/${id}`);
    return response.data;
  },

  // Crear nuevo contrato
  create: async (contractData) => {
    const formData = new FormData();

    // Agregar todos los campos al FormData
    Object.keys(contractData).forEach(key => {
      if (contractData[key] !== null && contractData[key] !== undefined) {
        if (key === 'documento' && contractData[key] instanceof File) {
          formData.append('documento', contractData[key]);
        } else {
          formData.append(key, contractData[key]);
        }
      }
    });

    const response = await api.post('/contracts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Actualizar contrato
  update: async (id, contractData) => {
    const formData = new FormData();

    // Agregar todos los campos al FormData
    Object.keys(contractData).forEach(key => {
      if (contractData[key] !== null && contractData[key] !== undefined) {
        if (key === 'documento' && contractData[key] instanceof File) {
          formData.append('documento', contractData[key]);
        } else {
          formData.append(key, contractData[key]);
        }
      }
    });

    const response = await api.put(`/contracts/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Eliminar (rescindir) contrato
  delete: async (id, motivo) => {
    const response = await api.delete(`/contracts/${id}`, {
      data: { motivo }
    });
    return response.data;
  },

  // Obtener estadísticas
  getStats: async () => {
    const response = await api.get('/contracts/stats/summary');
    return response.data;
  },

  // Aprobar contrato pendiente
  aprobar: async (id) => {
    const response = await api.post(`/contracts/${id}/aprobar`);
    return response.data;
  },

  // Rechazar contrato pendiente
  rechazar: async (id, motivo) => {
    const response = await api.post(`/contracts/${id}/rechazar`, { motivo });
    return response.data;
  }
};
